import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import routes from "./route.config";
import './App.css';
import '@chatui/core/dist/index.css';

declare global {
    var isMobile: boolean;
    var isPhone: boolean;
    var aiName: string;
    var apiBaseUrl: string;
    var apimKey: string;
    var welcomeMessage: string;
    var aiAskMessage: string;
}

export default function App(props: any) {
    var ua = navigator.userAgent;
    var os = (function () {
        var isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isTablet =
                /(?:iPad|PlayBook)/.test(ua) ||
                (isAndroid && !/(?:Mobile)/.test(ua)) ||
                (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isWeChat = /(?:micromessenger)/.test(ua.toLocaleLowerCase()),
            isPc = !isPhone && !isAndroid && !isSymbian;

        return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid: isAndroid,
            isPc: isPc,
            isWeChat: isWeChat,
        };
    })();

    global.isMobile = os.isAndroid || os.isPhone;
    global.isPhone = os.isPhone;
    global.aiName = props.aiName;
    global.apiBaseUrl = props.apiBaseUrl;
    global.apimKey = props.apimKey;
    global.welcomeMessage = props.welcomeMessage;
    global.aiAskMessage = props.aiAskMessage;

    // 2026-09-14: 按 visualViewport 锁定高度；聚焦时再量一次，避免 iOS 键盘先弹出、高度后更新
    useEffect(() => {
        const applyHeight = () => {
            const viewport = window.visualViewport;
            const height = viewport?.height ?? window.innerHeight;
            const offsetTop = viewport?.offsetTop ?? 0;
            document.documentElement.style.setProperty("--app-height", `${Math.round(height)}px`);
            document.documentElement.style.setProperty("--app-offset-top", `${Math.round(offsetTop)}px`);
        };
        const onFocusIn = (e: FocusEvent) => {
            const target = e.target as HTMLElement | null;
            if (!target || (target.tagName !== "TEXTAREA" && target.tagName !== "INPUT"))
                return;
            document.documentElement.classList.add("kb-open");
            applyHeight();
            window.setTimeout(applyHeight, 80);
            window.setTimeout(applyHeight, 320);
        };
        const onFocusOut = () => {
            document.documentElement.classList.remove("kb-open");
            window.setTimeout(applyHeight, 80);
        };
        applyHeight();
        window.visualViewport?.addEventListener("resize", applyHeight);
        window.visualViewport?.addEventListener("scroll", applyHeight);
        window.addEventListener("resize", applyHeight);
        document.addEventListener("focusin", onFocusIn);
        document.addEventListener("focusout", onFocusOut);
        return () => {
            window.visualViewport?.removeEventListener("resize", applyHeight);
            window.visualViewport?.removeEventListener("scroll", applyHeight);
            window.removeEventListener("resize", applyHeight);
            document.removeEventListener("focusin", onFocusIn);
            document.removeEventListener("focusout", onFocusOut);
        };
    }, []);

    return (
        <div className="app-shell">
            <BrowserRouter>
                <Suspense fallback={<></>}>
                    <Switch>
                        {routes.map((item, index) => {
                            return <Route
                                key={index}
                                exact={item.isExact}
                                path={item.path}
                                component={item.component}
                            />
                        })}
                    </Switch>
                </Suspense>
            </BrowserRouter>
        </div>
    );
}
